import { ChangeEvent, ReactElement, useMemo } from 'react';
import { Plan, Subscription, TaxDetails, OrderContext } from '@localstack/types';

import { groupMultiIntervalPlans } from '@localstack/services';

import { List, RadioGroup } from '@mui/material';

import { PlanListItem } from './components';

export interface PlansList {
  plans: Plan[];
  context: OrderContext;
  isAdminMode: boolean;
  selected?: Optional<Plan>;
  subscription?: Optional<Subscription>;
  tax?: Optional<TaxDetails>;
  onSelect?: (plan: Plan) => unknown;
}

export const PlansList = ({
  plans,
  context,
  selected,
  subscription,
  tax,
  onSelect,
  isAdminMode,
}: PlansList): ReactElement => {
  const handleRadioGroupChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e?.currentTarget?.value;
    onSelect?.(plans.find((p) => p.id === value) as Plan);
  };

  const groupedPlanVariants = useMemo(() => groupMultiIntervalPlans(plans), [plans]);

  return (
    <RadioGroup value={selected?.id ?? ''} onChange={handleRadioGroupChange}>
      <List disablePadding>
        {groupedPlanVariants.map((variants, groupIndex) => {
          const firstVariant = variants[0];
          if (!firstVariant) return null;

          return (
            <PlanListItem
              key={firstVariant.id}
              planVariants={variants}
              selected={selected}
              subscription={subscription}
              groupIndex={groupIndex}
              totalGroups={groupedPlanVariants.length}
              context={context}
              isAdminMode={isAdminMode}
              tax={tax}
              onSelect={onSelect}
            />
          );
        })}
      </List>
    </RadioGroup>
  );
};
